import React from 'react'
import MyMedicine from '../Components/MyMedicineComp/MyMedicine'

const MyMedicineView = () => {
  return (
    <div>
        <MyMedicine />
    </div>
  )
}

export default MyMedicineView